import React, { ReactElement, useEffect, useState, useContext } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import gridStyle from '@pages/forms/Grid.module.scss';
import { getStringIndex, setFormDataValues, setCurrentFormikValues, navigateToError } from '@utils';
import VicFinesContext from '@pages/forms/VicFinesFormContext';
import { getInitiate, checkExistingForm, getPartialForm } from '@api';
import { FormType } from '@constants';
import { Accordion, FormLoading } from '@components';
import { useFormikContext } from 'formik';
import ClockIcon from '../../../../images/clock.svg';
import styles from './ExtensionStep0.module.scss';

interface iProps {
  formikRef: any;
}

// const { REACT_APP_SITECORE_API_ENDPOINT: API_URL, REACT_APP_PATH_FAMILY_VIOLENCE_SCHEME: PATH_FVS } = process.env;
function ExtensionStep0({ formikRef }: iProps): ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const pathElementArray = location.pathname.split('/');
  const { tooltips } = useContext(VicFinesContext);
  const stepIndex = getStringIndex(pathElementArray, 'step');
  const stepIndexDiff = stepIndex - pathElementArray.length;
  const pathNameLessLastSegment = stepIndex ? location.pathname.split('/').slice(0, stepIndexDiff).join('/') : location.pathname;
  const validTitles = Object.keys(tooltips).filter((v) => v.includes('step0'));
  const formikcontext = useFormikContext();
  function getStringForSort(stringVal: string): string {
    return stringVal.substring(stringVal.indexOf('p') + 1, stringVal.indexOf('|'));
  }
  validTitles.sort((stringA, stringB) => Number(getStringForSort(stringA)) - Number(getStringForSort(stringB)));

  const { ob } = useParams<{ ob?: string }>();
  useEffect(() => {
    // if resume with #, re - calculate it.
    let pathNameLessLastSegmentOnLoad = '';
    let obNumFromPath = '';
    if (window.location.hash) {
      window.history.pushState({}, '', window.location.pathname + window.location.hash.replaceAll('#', ''));
      const currentUrl = window.location.pathname;
      const pathUrlArray = currentUrl.split('/');
      const stepCurrentIndex = getStringIndex(pathUrlArray, 'step');
      const stepIndexDiffOnLoad = stepCurrentIndex - pathUrlArray.length;
      pathNameLessLastSegmentOnLoad = stepCurrentIndex ? pathUrlArray.slice(0, stepIndexDiffOnLoad).join('/') : currentUrl;
      obNumFromPath = pathUrlArray.includes('step0') && pathUrlArray[stepCurrentIndex + 1] ? pathUrlArray[stepCurrentIndex + 1] : '';
    }
    const obNum = obNumFromPath || ob;
    if (obNum) {
      setLoading(true);
      formikcontext.setFieldValue('OBLIGATION_NUMBER', obNum);
      checkExistingForm(obNum, 'PaymentExtension')
        .then((valueOfExistingform) => {
          // if (!valueOfExistingform?.PartialFormID) {
          //   setLoading(false);
          //   navigate(`${pathNameLessLastSegment || pathNameLessLastSegmentOnLoad}/step0`);
          //   return;
          // }
          let currentStep = '';
          let partialFormID = 0;
          const partialFormOption = valueOfExistingform.CheckingExisting;
          const canSave = valueOfExistingform.CanSave;
          let savingoption = '';
          let debtorID = 0;
          if (partialFormOption === 'no' && valueOfExistingform.DebtorID && valueOfExistingform.PartialFormID) {
            return;
          }
          if (valueOfExistingform.CheckingExisting === 'yes') {
            partialFormID = valueOfExistingform.PartialFormID!;
            formikcontext.setFieldValue('PartialFormID', partialFormID);
            savingoption = valueOfExistingform.CanSave ? 'yes' : 'no';
            if (valueOfExistingform.PartialFormID) {
              getPartialForm(valueOfExistingform.PartialFormID)
                .then((resBody) => {
                  if (typeof resBody === 'string') {
                    if (resBody === 'Unauthorised') {
                      navigateToError();
                    }
                  } else {
                    const formData = JSON.parse(resBody.FormData);
                    const keys = Object.keys(resBody);
                    keys.forEach((key) => {
                      if (key === 'FormData') {
                        setFormDataValues(formData, formikRef?.current?.values.FormData, formikRef, 'FormData');
                        setCurrentFormikValues(formData, formikRef?.current?.values, formikRef);
                      } else if (resBody[key]) {
                        formikcontext.setFieldValue(`${key}`, resBody[key]);
                      }
                    });
                  }
                  setLoading(false);
                })
                .catch((e) => console.log(e));
            }
          } else {
            debtorID = valueOfExistingform.DebtorID!;
            savingoption = 'no';
            formikcontext.setFieldValue('DebtorID', debtorID);
          }
          formikcontext.setFieldValue('SaveOptions', savingoption);
          getInitiate(obNum, FormType.EXTENSION).then((value) => {
            if (value.Number) {
              if (value.Step !== '/step8' && value.Step !== '/step9') {
                // legacy logic
                if (partialFormOption === 'no' && canSave === true) {
                  // go to Which statement best describes you? page - first or third
                  currentStep = '/step3';
                } else {
                  currentStep = '/step4';
                }
                // formikRef.current.setFieldTouched('ApplicationLodger'); // temp solution, better to get field name from form config.
              } else {
                currentStep = '/step4';
              }
            } else {
              currentStep = '/step0';
            }
            navigate(`${pathNameLessLastSegment || pathNameLessLastSegmentOnLoad}${currentStep}`);
            setLoading(false);
          });
        })
        .catch(() => {
          console.log('Caught p2');
        });
    }
    return () => {
      setLoading(false);
    };
  }, []);
  return (
    <>
      {loading && <FormLoading />}
      {!loading && (
        <div className={gridStyle.form}>
          <div className="vfH2">Before you start</div>
          {validTitles.map((v) => {
            const getTitles = v.substring(v.indexOf('|'), v.length).replaceAll('|', ' ');
            return <Accordion title={getTitles} key={v} openByDefault={false} popupContent={tooltips[v]} />;
          })}
          <div className={styles.infoDiv}>
            <img src={ClockIcon} alt="alarm clock" />
            <span className={styles.info}>Please allow up to 12 minutes to complete this form.</span>
          </div>
        </div>
      )}
    </>
  );
}

export default ExtensionStep0;
